import React, { useContext, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataTable from "../../../../components/DataTable";
import {
  ALL_VEHICLE_INSPECTIONS_QUERY,
  ALL_VEHICLE_INSPECTIONS_MASTER_QUERY
} from "../../../../graphql/Vehicles/Vehicles.graphql";

import { ModalContext } from "../../../../components/ModalProvider";

import {
  VEHICLE_INSPECTION_COLUMNS,
  VEHICLE_INSPECTIONS_MASTER_COLUMNS
} from "../columns";

import {
  EditVehicleInspectionForm,
  AddVehicleInspectionMasterForm,
  EditVehicleInspectionMasterForm
} from "../../../../components/Vehicles";

function Inspections({ filters }) {
  const [selected, setSelected] = useState([]);
  const { setModalOpen } = useContext(ModalContext);
  const { id } = useParams();
  const handleAddVehicleInspection = () => {
    setModalOpen(
      true,
      <AddVehicleInspectionMasterForm
        id={id}
        onComplete={() => setModalOpen(false, "")}
      />
    );
  };

  const onSelectAll = useCallback((allSelected, InspectionTypeRecIdRefs) => {
    setSelected(prev => {
      const curr = [...prev];
      for (const RecId of InspectionTypeRecIdRefs) {
        const idx = curr.findIndex(item => item === RecId);
        if (allSelected) {
          if (idx > -1) {
            curr.splice(idx, 1);
          }
        } else if (idx < 0) {
          curr.push(RecId);
        }
      }
      return curr;
    });
  }, []);

  const onSelect = useCallback(vehicleInspectionMaster => {
    setSelected(prev => {
      const curr = [...prev];
      const idx = curr.findIndex(
        item => item === vehicleInspectionMaster.InspectionTypeRecIdRef
      );
      if (idx > -1) {
        curr.splice(idx, 1);
      } else {
        curr.push(vehicleInspectionMaster.InspectionTypeRecIdRef);
      }

      return curr;
    });
  }, []);

  return (
    <div className="container-inspections">
      <div className="page-head-end">
        <Button
          className="add-button"
          color="success"
          size="small"
          onClick={handleAddVehicleInspection}
        >
          <Icon>
            <FontAwesomeIcon icon="plus" />
          </Icon>
          <span>Add</span>
        </Button>
      </div>
      <div className="container-vehicle-inspections">
        <DataTable
          columns={VEHICLE_INSPECTIONS_MASTER_COLUMNS({
            onSelectAll,
            onSelect,
            selected
          })}
          dataQuery={ALL_VEHICLE_INSPECTIONS_MASTER_QUERY}
          initialSortBy={[
            {
              id: "InspectionType",
              desc: false
            }
          ]}
          name="VehicleInspectionsMaster"
          where={{ VehicleRecIdRef: parseInt(id) }}
          onRowClick={VehicleInspectionMaster =>
            setModalOpen(
              true,
              <EditVehicleInspectionMasterForm
                VehicleInspectionMaster={VehicleInspectionMaster}
                onComplete={() => setModalOpen(false, "")}
              />
            )
          }
        />
      </div>
      <hr />
      <div className="container-vehicle-inspections">
        <DataTable
          columns={VEHICLE_INSPECTION_COLUMNS}
          dataQuery={ALL_VEHICLE_INSPECTIONS_QUERY}
          initialSortBy={[{ id: "InspectionDate", desc: true }]}
          name="VehicleInspection"
          where={
            selected.length
              ? {
                  ...filters,
                  VehicleRecIdRef: parseInt(id),
                  InspectionTypeRecIdRef_in: selected
                }
              : { ...filters, VehicleRecIdRef: parseInt(id) }
          }
          onRowClick={VehicleInspection =>
            setModalOpen(
              true,
              <EditVehicleInspectionForm
                VehicleInspection={VehicleInspection}
                onComplete={() => setModalOpen(false, "")}
              />
            )
          }
        />
      </div>
    </div>
  );
}
Inspections.propTypes = {
  filters: PropTypes.object
};
export default Inspections;
